<template>
  <div
    class="DetailActionAndMeta">
    <!-- CTA -->
    <DetailCta
      v-if="!loading"
      class="DetailActionAndMeta_cta"
      :app="app"
      :user-is-customer="$root.userIsCustomer"
      key="DAAM-cta"
    />

    <BasePlaceholder
      v-if="loading"
      width="100%"
      height="40px"
    />

    <!-- CAPABILITIES -->
    <section
      class="mt-3">
      <h3>Included in the app</h3>
      <BaseCapabilities
        class="mt-2"
        :capabilities="app.capability"
      />
    </section>

    <!-- DATASETS -->
    <section
      v-if="app.dataSets"
      class="mt-3"
      key="DAAM-datasets">
      <h3>DataSets Available</h3>
      <AvailableDatasetsList
        class="mt-2"
        :available-datasets="app.dataSets"
        @see-datasets-click="$emit('see-datasets-click')"
      />
    </section>

    <!-- COMPATIBLE APPS -->
    <section
      v-if="app.compatibleApps && app.compatibleApps.length"
      class="mt-3">
      <h3>Compatible apps</h3>
      <CompatibleAppList
        class="mt-2"
        :compatible-apps="app.compatibleApps"
      />
    </section>

    <!-- COMPATIBLE DATA SOURCES -->
    <section
      v-if="app.dataSource && app.dataSource.length"
      class="mt-3">
      <h3>Compatible data sources</h3>
      <CompatibleAppList
        class="mt-2"
        :compatible-apps="app.dataSource"
      />
    </section>

    <!-- SETUP EFFORT & POWERUP GUIDE -->
    <section
      v-if="loading || app.setupEffort"
      class="mt-3">
      <h3>Setup effort</h3>
      <SetupEffortGauge
        v-if="!loading"
        key="SetupEffort"
        class="mt-2"
        :difficulty="app.setupEffort.difficulty"
        :label="app.setupEffort.label"
      />

      <BasePlaceholder
        v-else
        class="mt-2"
        width="100%"
        height="24px"
      />

      <div
        v-if="app.powerupRequirements"
        class="font-12 mt-2"
        key="PowerupRequirements">
        <h6
          class="color-mute uppercase pb-half">
          What you will need
        </h6>
        <p>
          {{ app.powerupRequirements }}
        </p>
        <p
          v-if="app.documentationLink"
          class="mt-half"
          key="DocumentationLink">
          For more setup help please
          <a
            class="link color-dark-blue"
            :href="app.documentationLink">
            read the power-up guide
          </a>
        </p>
      </div>
    </section>

    <!-- TAGS, VERSION, & PLATFORM -->
    <section
      class="mt-3">
      <h3>Additional details</h3>
      <div
        v-if="loading || app.tags"
        class="MetaTags _meta">
        <h6
          class="_title">
          TAGS
        </h6>
        <BaseTags
          v-if="!loading"
          key="MetaTags"
          :tags="app.tags"
        />
        <BasePlaceholder
          v-else
          :blocks="3"
          width="60px"
          height="16px"
        />
      </div>

      <div
        v-if="loading || app.lastUpdated"
        class="MetaLastUpdated _meta"
        key="MetaLastUpdated">
        <h6
          class="_title">
          LAST UPDATED
        </h6>
        <span
          v-if="!loading">
          {{ lastUpdatedFormatted(app.lastUpdated) }}
        </span>
        <BasePlaceholder
          v-else
          width="150px"
          height="16px"
        />
      </div>

      <div
        v-if="loading || app.version"
        class="MetaVersion _meta">
        <h6
          class="_title">
          VERSION
        </h6>
        <span
          v-if="!loading"
          key="MetaVersion">
          {{ app.version }}
        </span>
        <BasePlaceholder
          v-else
          width="100px"
          height="16px"
        />
      </div>
    </section>
  </div>
</template>

<script>
import Moment from 'moment';
import BasePlaceholder from '@/components/BasePlaceholder.vue';
import DetailCta from '@/components/DetailCta.vue';
import SetupEffortGauge from '@/components/SetupEffortGauge.vue';
import BaseCapabilities from '@/components/BaseCapabilities.vue';
import AvailableDatasetsList from '@/components/AvailableDatasetsList.vue';
import CompatibleAppList from '@/components/CompatibleAppList.vue';
import BaseTags from '@/components/BaseTags.vue';

export default {
  name: 'DetailActionAndMeta',

  components: {
    BasePlaceholder,
    DetailCta,
    SetupEffortGauge,
    BaseCapabilities,
    AvailableDatasetsList,
    CompatibleAppList,
    BaseTags,
  },

  props: {
    app:     { type: Object },
    loading: { type: Boolean, default: true },
  },

  methods: {
    lastUpdatedFormatted(timestamp) {
      return Moment(timestamp).format('LL');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.DetailActionAndMeta ._meta {
  margin-top: 16px;
  font-size: 12px;
}

.DetailActionAndMeta ._meta ._title {
  color: $mute;
  margin-bottom: 4px;
}

@media only screen and (max-width: 800px) {
  .DetailActionAndMeta_cta {
    display: none !important;
  }
}
</style>
